import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsOfUse from "../pages/terms/page";
import PasseioDeLanchaCapitolio from "../pages/passeio-de-lancha-capitolio/page";
import AluguelDeLanchaCapitolio from "../pages/aluguel-de-lancha-capitolio/page";
import PasseioDeJetSkiCapitolio from "../pages/passeio-de-jet-ski-capitolio/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/passeio-de-lancha-capitolio",
    element: <PasseioDeLanchaCapitolio />,
  },
  {
    path: "/aluguel-de-lancha-capitolio",
    element: <AluguelDeLanchaCapitolio />,
  },
  {
    path: "/passeio-de-jet-ski-capitolio",
    element: <PasseioDeJetSkiCapitolio />,
  },
  {
    path: "/politica-de-privacidade",
    element: <PrivacyPolicy />,
  },
  {
    path: "/termos-de-uso",
    element: <TermsOfUse />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;